import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rupiah',
})
export class RupiahPipe implements PipeTransform {
  DECIMAL_SEPARATOR = '.';
  THOUSANDS_SEPARATOR = ',';

  transform(
    value: number | string,
    symbol: string = 'Rp ',
    fractionSize: number = 0
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    let numericValue = Number(value.toString().replace(/[^0-9]/g, ''));
    if (isNaN(numericValue)) {
      return '';
    }

    let integer = numericValue
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
    return symbol + integer;
  }

  parse(value: string): string {
    return value.replace(/[^\d]/g, '');
  }
}
